import React, { Component } from 'react'
import { Data } from './data'
import './style.css'
import TypeFinger from './TypeFinger'
import TypeWarn from './TypeWarn'

export default class Type extends Component {

	state = { 
		randNum : 0,
		inputer : '',
		isWarn : ''
	}
	
	
	componentDidMount() {
        
		document.querySelector('input').focus()

	}

	inputFx = (e) => {
		
		this.setState({ inputer : e.target.value })
		
	}
	
	checkerFx = (e) => {

		let keyCode = e.key
			
		if(keyCode === 'Enter' && this.state.inputer === Data[ this.state.randNum ]) {

			this.warnFx('Success!')
            this.correctFx()
            
		} else if (keyCode === 'Enter' && this.state.inputer !== Data[ this.state.randNum ]) {
			
			this.warnFx('Wrong!')
			this.setState({ inputer : '' })
		
		} else if (keyCode === 'Backspace') {
			
			this.warnFx('Backspace!')
			this.setState({ inputer : '' })
		
		} else {
			
			this.warnFx(keyCode)
		
		}
	}


    correctFx = () => {

        let rander = Math.floor( (Math.random() * Data.length) - 1)
	
		this.setState({ 
            randNum : rander,
            inputer : ''
        })
    }
    
    
 	warnFx = (foo) => {

		this.setState({ isWarn : foo })
			
		setTimeout( () => {
			
			this.setState({ isWarn : 0 })
			
        }, 1000)
		
    }
		

	render() {

        let theWord = Data[ this.state.randNum ]

        const Banner = {
			backgroundImage: 'url("/type.jpg")',
			height: '100vh'
        }
        
		return(

            <div className='WideContainer' style={Banner}>

            	
				{ this.state.isWarn ? <TypeWarn message = { this.state.isWarn } /> : null }

				<div id = 'TypeTop'>

					<div id = 'TypeBox'>
					    <h1>{ theWord }</h1>
					    <input type='text' value = { this.state.inputer } onChange = { this.inputFx } onKeyDown = { this.checkerFx }/>
							
					</div>

		        </div>

				<TypeFinger words = { this.state.inputer }  />
					
            </div>

		)
	}
}




// WEBPACK FOOTER //
// ./src/components/type/index.js